<template>
     <DxDataGrid :data-source="dsMomenteCalcul" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id" @row-click="onRowClick">

        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="300" :height="330" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" /> 
            </DxPopup>
            <DxFormGrid :col-count=1>
                <DxItem data-field="Nume"/>
                <DxItem data-field="Zi" editor-type="dxNumberBox" :editor-options="numberBoxOptions"/>
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Moment Calcul
            </div>
        </template>

        <DxColumn data-field="Nume" caption="Nume"/>
        <DxColumn data-field="Zi" caption="Zi"/>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" height="330px" width="300px">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Moment Calcul
            </div>
        </template>
        <DxForm :col-count="1" :data-source="newMoment" label-alignment="center">
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newMoment.Nume" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Zi" :is-required="true">
                <template #default>
                    <DxNumberBox :value="newMoment.Zi" :min="1" :max="31" :step="1" :show-clear-button="true" :show-spin-buttons="true" @value-changed="onZiValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
    import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem,
    DxItem as DxFormItem,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxSearchPanel,
    DxMasterDetail
    } from 'devextreme-vue/data-grid';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import ODataStore from 'devextreme/data/odata/store';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref, markRaw } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxLookup, DxNumberBox } from 'devextreme-vue';
    import SAL_MomenteCalcul from '@/services/SAL/SAL_MomenteCalcul';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxNumberBox,
            DxMasterDetail,
        },
        data() {
            return {
                dsMomenteCalcul: {} as DataSource,
                dataGridRef: ref<DxDataGrid | null>(null),
                addPopupVisible: false,
                newMoment: {
                    Nume: '',
                    Zi: 1
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                numberBoxOptions: {
                    min: 0,
                    max: 31,
                    step: 1,
                    showSpinButtons: true,
                    showClearButton: true,
                    height: 50,
                },
            }
        },
        mounted() {
            this.dsMomenteCalcul = markRaw(new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `SAL_MomenteCalcul`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            }))
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            onNumeValueChanged(e: any) {
                this.newMoment.Nume = e.value
            },
            onZiValueChanged(e: any) {
                this.newMoment.Zi = e.value
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newMoment.Nume = ''
                this.newMoment.Zi = 1
            },
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onSaveAdd() {
                if (!this.newMoment.Nume || this.newMoment.Nume.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                    return
                }

                SAL_MomenteCalcul.save(this.newMoment).then((moment) => {
                    this.addPopupVisible = false
                    this.newMoment = {
                        Nume: '',
                        Zi: 1
                    }
                    notify("Datele au fost salvate cu succes!", "success", 2000)
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                }) 
            },
            onRowClick(e: any) {
                const id = e.data.Id
                this.$router.push({ 
                    name: 'MomenteCalculDetalii', 
                    params: { id: id } 
                });
            }
        }
    })
</script>
